import React, { FC, useEffect, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userState } from "../../../states/userState";
import classes from "./RecordDetailHeader.module.scss";
import DialogButton from "../../uikit/atoms/buttons/card/DialogButton";
import { foreColor, foreColorCode } from "../../../commons/colors";
import { SaveButton } from "../../uikit/atoms/buttons/SaveButton";
import { CancelButton } from "../../uikit/atoms/buttons/CancelButton";
import logo from "../../../assets/logo.svg";
import { CircularProgress, useMediaQuery, useTheme } from "@mui/material";
import { loadingState, loadingText } from "../../../states/loadingState";
import { useCardAccessor } from "../../../hooks/useCardAccessor";
import apiClient from "../../../lib/apiClient";
import { ProcessInfo } from "../RecordDetailForm";

interface RecordDetailHeaderProps {
  onSave: () => void;
  onCancel: () => void;
  compDate: string;
  setCompDate: React.Dispatch<React.SetStateAction<string>>;
  setTargetProcess: React.Dispatch<React.SetStateAction<ProcessInfo>>;
  processData: { id: string; text: string }[];
  baseData: { id: string; text: string }[];
}
const createHeaderText = (viewId: number) => {
  if (viewId === 0 || viewId === 50111 || viewId === 5253 || viewId == 54) {
    return "PTC_";
  } else {
    return "PVC_";
  }
};

const RecordDetailHeader: FC<RecordDetailHeaderProps> = (props) => {
  const {
    onSave,
    onCancel,
    compDate,
    setCompDate,
    setTargetProcess,
    processData,
    baseData,
  } = props;
  const sleep = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const {
    isPolling,
    isDetected,
    CardReaderActive,
    CardReaderStop,
    displayMessage,
    cardId,
    cardType,
    isUSBConnected,
  } = useCardAccessor();
  const user = useRecoilValue(userState);
  const [isApiExecuting, setIsApiExecuting] = useState(false);
  const [isFound, setIsFound] = useState(false); //このフラグでカードが未登録ですと表示する。
  // const [compDate, setCompDate] = useState("初期値");
  console.log("processData", processData, baseData);
  const productNo = baseData.find((p) => p.id === "B_製番")?.text ?? "";
  const siteName = baseData.find((p) => p.id === "B_現場名")?.text ?? "";
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);
  //カード起動ボタンクリック
  const onClickCardReaderActive = async () => {
    console.log("onClickCardReaderActive");
    await CardReaderActive();
    setCompDate("初期値");
  };
  //カード停止ボタンクリック
  const onClickCardReaderStop = async () => {
    await CardReaderStop();
    setCompDate("初期値");
  };
  //保存ボタンクリック
  const handleSaveClick = async () => {
    await CardReaderStop();
    onSave();
  };
  //キャンセルボタンクリック

  const handleCancelClick = async () => {
    await CardReaderStop();
    onCancel();
  };
  //カードリーダ状態表示
  const createDisplayMessage = () => {
    if (isPolling) {
      if (isDetected) {
        return compDate === "初期値" ? " " : compDate;
        // return "ICカードリーダにカードをかざしてください";
      } else {
        //カード未検出時
        return "ICカードリーダにカードをかざしてください";
      }
    } else {
      if (isDetected || isApiExecuting) {
        return compDate === "初期値" ? " " : compDate;
      } else {
        return isUSBConnected === false
          ? "ICカードリーダが接続されていません"
          : "ICカードリーダを起動してください";
      }
    }
  };
  useEffect(() => {
    //カード検出時のAPI実行
    const startCard = async () => {
      await CardReaderActive();
    };
    const executeApi = async () => {
      setIsApiExecuting(true);
      setLoadingAnimation(true);
      setLoadingText("読み込み中...");
      try {
        console.log("送信前", cardId, cardType);
        //カード検索
        const query = `cardId=${encodeURIComponent(cardId)}`;
        console.log("query", query);
        let response = await apiClient.get(`/cards/getcards/?${query}`);
        setLoadingAnimation(false);
        setLoadingText("");
        const lIsFound = response.data.length > 0;
        const cardData = response.data[0];
        console.log("response", response.data);
        setIsFound(lIsFound);
        if (lIsFound) {
          //   //カードが登録済みの場合-工程（完了日）を取得
          //   // const send_data = [cardId, cardType, cardData["$id"].value];
          //   // let json_wrapper = { data: send_data };
          //   // response = await apiClient.put("/cards/update_card", json_wrapper);
          //   // console.log(response);
          //   setApiParams({
          //     id: cardData["$id"].value,
          //     compDate: cardData.processName.value,
          //     cardId: cardData.card_id.value,
          //     cardType: cardData.card_type.value,
          //   });
          console.log("cardData", cardData.processName.value);
          setCompDate(cardData.processName.value);
          setTargetProcess({
            id: `${createHeaderText(user.viewId)}${cardData.processName.value}`,
            date: new Date(),
          });
          await sleep(1000);
        } else {
          setCompDate("未登録");
          setTargetProcess({ id: "", date: "" });
          await sleep(1000);
          //   setApiParams({
          //     id: "",
          //     compDate: "未登録",
          //     cardId: cardId,
          //     cardType: cardType,
          //   });
          //カードが登録されていない場合（未登録をセット）
          // const send_data = [cardId, cardType];
          // let json_wrapper = { data: send_data };
          // response = await apiClient.post(
          //   "/cards/postcards",
          //   json_wrapper
          // );
        }
      } catch (e) {
        alert(e);
      } finally {
        setIsFound(false);
        setCompDate("初期値");
        //APIを起動
        await startCard();
        setLoadingAnimation(false);
        setLoadingText("");
        setIsApiExecuting(false);
      }
    };
    if (isDetected == true && !isApiExecuting) {
      //カード検出かつAPI実行中でない場合

      //APIを実行
      executeApi();
    }
  }, [isDetected]);
  //カード検出時のポーリング停止
  useEffect(() => {
    const stopPolling = async () => {
      await CardReaderStop();
    };
    if (isPolling && isDetected) {
      stopPolling();
    }
  }, [isDetected, isPolling]);
  //クリーンアップ
  //クリーンアップ
  useEffect(() => {
    const cleanup = async () => {
      await CardReaderStop();
    };
    return () => {
      cleanup();
    };
  }, []);

  return (
    <div className={classes.root} style={foreColor(user?.mode ?? "lite")}>
      {!isMobile && (
        <div className={classes.card}>
          <img src={logo} className={classes.Applogo} alt="logo" />
          {isPolling && (
            <div style={{ marginRight: "5px" }}>
              <CircularProgress
                size="1.2rem"
                sx={foreColor(user?.mode ?? "lite")}
              />
            </div>
          )}
          {isApiExecuting && (
            <div
              className={classes.detected}
              style={{
                backgroundColor: compDate === "未登録" ? "red" : "yellow",
              }}
            >
              {compDate === "未登録" ? "未登録" : createDisplayMessage()}
            </div>
          )}
          {!isApiExecuting && (
            <p
              className={classes.title}
              style={{
                color:
                  isUSBConnected === false
                    ? "red"
                    : foreColorCode(user?.mode ?? "lite"),
              }}
            >
              {createDisplayMessage()}
            </p>
          )}
          {/* 起動・停止 */}
          {isPolling ? (
            <div>
              <DialogButton
                label={"停止"}
                disabled={false}
                width={60}
                onClick={onClickCardReaderStop}
                colorStyle={"yesColor"}
              />
            </div>
          ) : (
            <div>
              <DialogButton
                label={"起動"}
                disabled={false}
                width={60}
                onClick={onClickCardReaderActive}
                colorStyle={"yesColor"}
              />
            </div>
          )}
        </div>
      )}
      <div className={classes.menu}>
        <div className={classes.info}>
          <div className={classes.infoItem} style={{ marginRight: "10px" }}>
            <p>製番</p>
            <p className={classes.productNo}>{productNo}</p>
          </div>
          <div className={classes.infoItem}>
            <p>現場名</p>
            <p className={classes.site}>{siteName}</p>
          </div>
        </div>
        <div className={classes.buttons}>
          <div>
            <p>保存</p>
            <SaveButton
              disabled={false}
              onClick={handleSaveClick}
              caption={"Save Changes"}
            />
          </div>
          <div>
            <p>終了</p>
            <CancelButton
              disabled={false}
              onClick={handleCancelClick}
              caption={"Cancel"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecordDetailHeader;
